<template>
    <div id="app" class="container-fluid mt-1">
        <div class="row justify-content-end mr-2">
            <nav-menu></nav-menu>
        </div>
        <div class="row mt-5">
            <router-view class="w-100"></router-view>
        </div>
    </div>
</template>

<script>
    import tickets from "./views/tickets";
    import SprintStatus from "./views/sprintStatus";
    import navMenu from "./components/navMenu";

    export default {
        name: 'App',
        components: {
            SprintStatus,
            tickets,
            navMenu
        }

    }
</script>

<style lang="css">

    #app {
        font-family: OpenSans, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        margin-top: 60px;
    }
</style>
